// src/modals/EventsViewerModal.jsx
// Phase 37 Plan 06 — extracted from src/App.jsx (was lines 4976-5006 pre-Plan-37-06).
//
// Scope: Phase 32 D-06 — read-only analytics validation modal. Dev-mode only.
// Reads tend:events via getEvents() (sync, defensive) and renders newest-first
// JSON-pretty. Never mutates events. Closed by × button, Escape key, or backdrop click.

import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { getEvents } from '../data/events.js';

export default function EventsViewerModal({ onClose }) {
  const [events, setEvents] = useState(() => getEvents().slice().reverse());
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);
  const refresh = () => setEvents(getEvents().slice().reverse());
  const json = JSON.stringify(events, null, 2);
  return (
    <div role="dialog" aria-modal="true" aria-label="Analytics events viewer"
         onClick={onClose}
         style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:1100,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div onClick={(e)=>e.stopPropagation()}
           style={{background:"var(--c-bg)",borderRadius:14,padding:20,maxWidth:720,width:"100%",maxHeight:"86vh",overflowY:"auto",boxShadow:"0 8px 40px rgba(0,0,0,0.25)",position:"relative"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
          <h3 style={{fontFamily:"var(--font-family-display)",color:"var(--c-heading)",margin:0,fontSize:"var(--font-h2)"}}>tend:events ({events.length})</h3>
          <div style={{display:"flex",gap:8}}>
            <button onClick={refresh} style={{background:"var(--c-btn-bg)",color:"var(--c-btn-text)",border:"none",borderRadius:18,padding:"5px 12px",fontSize:'var(--font-tiny)',fontWeight:600,cursor:"pointer"}}>Refresh</button>
            <button onClick={onClose} aria-label="Close events viewer" style={{background:"none",border:"none",cursor:"pointer",color:"var(--c-text-3)",padding:4,borderRadius:8,lineHeight:1,display:"flex"}}><X size={20}/></button>
          </div>
        </div>
        <pre style={{margin:0,padding:12,background:"var(--c-surface)",border:"1px solid var(--c-border)",borderRadius:8,fontSize:'var(--font-tiny)',fontFamily:"ui-monospace, SFMono-Regular, Menlo, monospace",overflow:"auto",maxHeight:"70vh",whiteSpace:"pre",color:"var(--c-text)"}}>{json || '(empty)'}</pre>
      </div>
    </div>
  );
}
